import React from 'react';
import { Stack, TextField, FormControl, Button } from '@mui/material';
import CountryHelper from '../../core/CountryHelper';
import NumericTextField from '../common/controls/NumericTextField';
import Utils from '../../core/Utils';
import { Regexes } from '../../core/Regexes';

const CustomerDetailsForm = ({
    customer,
    onChange,
    onComplete,
    onDelete,
    isNew = false,
    onCancel
}) => {
    const handleChange = (field, value) => {
        onChange({ ...customer, [field]: value });
    };

    const trimmedName = customer.customerBillingName?.trim() || '';
    const trimmedAddress = customer.customerBillingAddress?.trim() || '';
    const mobile = customer.customerBillingMobileNumber || '';
    const gst = customer.customerBillingGSTNumber || '';

    const isMobileValid = /^\d{10}$/.test(mobile);
    const isGSTValid = Utils.IsNullOrEmpty(gst) || (gst.length === 15 && Regexes.GST.test(gst));

    const isAddDisabled =
        Utils.IsNullOrEmpty(trimmedName) ||
        Utils.IsNullOrEmpty(trimmedAddress) ||
        !isMobileValid ||
        !isGSTValid;

    return (
        <Stack spacing={2} sx={{ border: '1px solid #ccc', p: 2, borderRadius: 2 }}>
            <FormControl fullWidth>
                <TextField
                    label="Customer Name"
                    variant="outlined"
                    error={!customer.customerBillingName}
                    value={customer.customerBillingName}
                    onChange={(e) => handleChange('customerBillingName', e.target.value)}
                />
            </FormControl>

            <FormControl fullWidth>
                <TextField
                    label="Customer Address"
                    variant="outlined"
                    error={!customer.customerBillingAddress}
                    value={customer.customerBillingAddress}
                    onChange={(e) => handleChange('customerBillingAddress', e.target.value)}
                />
            </FormControl>

            <FormControl fullWidth>
                <NumericTextField
                    label="Mobile Number"
                    variant="outlined"
                    error={!isMobileValid}
                    inputProps={{
                        maxLength: CountryHelper.GetMobileNumberMaxLength(),
                    }}
                    value={mobile}
                    setValue={(val) => handleChange('customerBillingMobileNumber', val)}
                />
            </FormControl>

            <FormControl fullWidth>
                <TextField
                    label="GST Number"
                    variant="outlined"
                    inputProps={{ maxLength: 15 }}
                    error={!Utils.IsNullOrEmpty(gst) && !isGSTValid}
                    value={gst}
                    onChange={(e) => handleChange('customerBillingGSTNumber', e.target.value)}
                />
            </FormControl>

            <Stack direction="row" spacing={2}>
                <Button
                    className="btn btn-primary"
                    variant="contained"
                    onClick={() => onComplete(customer)}
                    disabled={isNew && isAddDisabled}
                >
                    {isNew ? 'Add' : 'Save'}
                </Button>

                {onDelete && (
                    <Button variant="outlined" color="error" onClick={() => onDelete(customer)}>
                        Delete
                    </Button>
                )}

                {onCancel && (
                    <Button variant="text" className="btn btn-secondary" color="inherit" onClick={onCancel}>
                        Close
                    </Button>
                )}
            </Stack>
        </Stack>
    );
};

export default CustomerDetailsForm;
